<template>
  <div
    class="app-select"
    :class="{ 'app-select--disabled': disabled }"
    @click.stop="toggle"
  >
    <div class="app-select__control form-control form-control-light">
      <span class="app-select__value">
        {{ selectedLabel }}
      </span>
      <span v-if="isOpen">
        <Arrow
          :width="24"
          :height="24"
          fill="#79919c"
          :style="{ transform: 'rotate(180deg)' }"
          class="app-select__arrow"
        />
      </span>
      <span v-else>
        <Arrow
          :width="24"
          :height="24"
          fill="#79919c"
          class="app-select__arrow"
        />
      </span>
    </div>

    <div
      v-if="isOpen"
      class="app-select__dropdown form-control form-control-light"
    >
      <div
        v-for="option in options"
        :key="option.id"
        class="app-select__option"
        :class="{ 'is-selected': option.id === value }"
        @click.stop="select(option.id)"
      >
        {{ option.label }}
      </div>
    </div>
  </div>
</template>

<script>
import Arrow from "@/assets/icons/arrow.svg";

export default {
  name: "AppSelect",
  components: { Arrow },

  model: {
    prop: "value",
    event: "input",
  },

  props: {
    value: {
      type: [String, Number],
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "Выберите значение",
    },
  },

  data() {
    return {
      isOpen: false,
    };
  },

  computed: {
    selectedLabel() {
      const selected = this.options.find((opt) => opt.id === this.value);
      return selected ? selected.label : this.placeholder;
    },
  },

  methods: {
    toggle() {
      if (this.disabled) return;
      this.isOpen = !this.isOpen;
    },

    select(value) {
      this.$emit("input", value);
      this.isOpen = false;
    },

    close() {
      this.isOpen = false;
    },
  },

  mounted() {
    document.addEventListener("click", this.close);
  },

  beforeDestroy() {
    document.removeEventListener("click", this.close);
  },
};
</script>

<style scoped lang="less">
@import "../../assets/less/variables.less";

.app-select {
  position: relative;
  width: 220px;
  font-size: 14px;
}

.app-select__control {
  height: 36px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  cursor: pointer;
}

.app-select__arrow {
  display: flex;
  align-items: center;
  justify-content: center;
}

.app-select__dropdown {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  padding: 0;
  height: 340px;
  overflow-y: auto;
  background: #fff;
  z-index: 10;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.app-select__option {
  padding: 8px 12px;
  cursor: pointer;
}

.app-select__option:hover {
  background-color: #f5f5f5;
}

.app-select__option.is-selected {
  background-color: #e6f4ff;
  font-weight: 500;
}

.app-select--disabled {
  opacity: 0.5;
  pointer-events: none;
}
</style>
